import React__default from 'react';
import { clsx } from 'clsx';
import { s as styles } from '../../../TableTd.module-VWX0ir3B.mjs';

const TableTd = (props) => {
  return React__default.createElement("td", { className: clsx(styles.tableTd, props.className), "data-freeze": props.freeze, "data-shadowed": props.shadowed, "data-zds": true, headers: props.headers, role: "cell" }, props.children);
};

export { TableTd };
//# sourceMappingURL=TableTd.es.js.map
